import { Row } from "@visa/vds";
import ButtonGroup from "@visa/vds/button-group";
import ButtonText from "@visa/vds/button-text";
import Dialog from "@visa/vds/dialog";
import DialogCardBody from "@visa/vds/dialog-card-body";
import DialogCardFooter from "@visa/vds/dialog-card-footer";
import DialogCardHead from "@visa/vds/dialog-card-head";
import DialogCardHeadIcon from "@visa/vds/dialog-card-head-icon";
import DialogCardHeadTitle from "@visa/vds/dialog-card-head-title";
import Grid from "@visa/vds/grid";
import Icon from "@visa/vds/icon";
import Typography from "@visa/vds/typography";
import { AuthenticatedExternalUserRoutes } from "_constants/PageRoutes";
import { DateHelper } from "_helpers/DateHelper";
import MCSReadonlyField from "components/MCSReadonlyField";
import MCSSpace from "components/MCSSpace";
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const VSTSFutureSubscriptionExistWarningDialog = (props) => {
  const history = useHistory();
  const futureSubscription = props.futureSubscription

  const handleClickHyperLinkAction = () => {
    history.push({
      pathname: AuthenticatedExternalUserRoutes.SUBSCRIPTION_DETAILS,
      state: {
        subscriptionId: props.futureSubscription.id,
      },
    })
  }
  return (
    <>
      <Dialog
        aria-describedby="VSTS future subscription exist warning"
        onExit={() => { }}
        open={props.openSubscriptionWarningDialog}
        type="error"
        titleId="dialog-subscription-error"
      >
        <DialogCardHead>
          <DialogCardHeadIcon>
            <Icon name="error" resolution="low" />
          </DialogCardHeadIcon>
          <DialogCardHeadTitle id="dialog-title-manage-file">
            Error
          </DialogCardHeadTitle>
        </DialogCardHead>

        <DialogCardBody id="dialog-description-manage-file-field">
          <Grid>
            <Typography tag="h4">
              You already have an existing VSTS subscription that has a future start date.
            </Typography>
            <Row>
              <MCSReadonlyField
                label="Subscription Name:"
                text={futureSubscription && futureSubscription.subscriptionName}
              />
            </Row>
            <Row>
              <MCSReadonlyField
                label="Start Date:"
                text={futureSubscription && DateHelper.ToFormattedDate(futureSubscription.startDate)}
              />
            </Row>
            <Row>
              <MCSReadonlyField
                label="End Date:"
                text={futureSubscription && DateHelper.ToFormattedDate(futureSubscription.endDate)}
              />
            </Row>
            <Row style={{ marginTop: "15px" }}>
              <Typography tag="h4">Please go to <a style={{ cursor: "pointer" }} onClick={handleClickHyperLinkAction}>Subscription Information page</a> if you want to edit the start date of this subscription.</Typography>
            </Row>
          </Grid>
          <MCSSpace />
        </DialogCardBody>
        <DialogCardFooter>
          <ButtonGroup direction="right">
            <ButtonText
              colorScheme="primary"
              onClick={() => {
                props.setOpenSubscriptionWarningDialog(null);
              }}
            >
              OK
            </ButtonText>
          </ButtonGroup>
        </DialogCardFooter>
      </Dialog>
    </>
  );
};

export default VSTSFutureSubscriptionExistWarningDialog;
